/// <reference path="_references.ts"/>

module App.Chat {
	export interface $wamp {
		open(): void;
		subscribe(topic: string, handler: (message: Message[]) => void): ng.IPromise<Subscription>;
		unsubscribe(subscription: Subscription): ng.IPromise<void>;
		publish(topic: string, args: [Message], kwargs?: any, options?: any): ng.IPromise<void>;
		call(procedure: string, args?: [number, string], kwargs?: any, options?: any): ng.IPromise<{args: [any]}>;
	}

	export interface Message {
		[key: string]: any;

		id?: number;
		timestamp?: string;
		message: string;
		sender?: {
			id: number,
			name: string
		} | number;
		recipient?: {
			id: number,
			name: string
		} | number;
		read?: boolean;
	}

	export interface ChatUser {
		id: number;
		name: string;
		avatar?: string;
		lastmessage?: Message;
		unread: number;
		online: boolean;
		role: string;
	}

	export interface Subscription{

	}
}